/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeagueMatchdayResponse
 */
export interface LeagueMatchdayResponse {
    /**
     * 
     * @type {number}
     * @memberof LeagueMatchdayResponse
     */
    matchdayNumber: number;
    /**
     * 
     * @type {string}
     * @memberof LeagueMatchdayResponse
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof LeagueMatchdayResponse
     */
    scheduledDate?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeagueMatchdayResponse
     */
    fixtureIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LeagueMatchdayResponse
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the LeagueMatchdayResponse interface.
 */
export function instanceOfLeagueMatchdayResponse(value: object): value is LeagueMatchdayResponse {
    if (!('matchdayNumber' in value) || value['matchdayNumber'] === undefined) return false;
    if (!('fixtureIds' in value) || value['fixtureIds'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    return true;
}

export function LeagueMatchdayResponseFromJSON(json: any): LeagueMatchdayResponse {
    return LeagueMatchdayResponseFromJSONTyped(json, false);
}

export function LeagueMatchdayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueMatchdayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchdayNumber': json['matchdayNumber'],
        'name': json['name'] == null ? undefined : json['name'],
        'scheduledDate': json['scheduledDate'] == null ? undefined : json['scheduledDate'],
        'fixtureIds': json['fixtureIds'],
        'isComplete': json['isComplete'],
    };
}

export function LeagueMatchdayResponseToJSON(json: any): LeagueMatchdayResponse {
    return LeagueMatchdayResponseToJSONTyped(json, false);
}

export function LeagueMatchdayResponseToJSONTyped(value?: LeagueMatchdayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchdayNumber': value['matchdayNumber'],
        'name': value['name'],
        'scheduledDate': value['scheduledDate'],
        'fixtureIds': value['fixtureIds'],
        'isComplete': value['isComplete'],
    };
}

